<template>
  <div>
    <main id="main">
      <Loading :isProcessing="isProcessing"></Loading>
      <div class="l-contents">
        <h1 class="l-pageTitle">初期パスワード設定</h1>
        <p class="l-text u-mb20">パスワードは10文字以上としてください。<br>大文字、小文字、数字、記号（#,$,@など）を含めてください。</p>
        <div class="l-contentsBox">
          <table class="l-form-table">
            <tr>
              <th class="v-middle"><span>メールアドレス</span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <TextBox v-model.trim="$v.form.$model.mailAddress" placeholder="メールアドレス" name="mailAddress" />
                  <ValidationErrorMessage v-show="$v.form.mailAddress.$error && !$v.form.mailAddress.required" validation="required" />
                  <ValidationErrorMessage v-show="$v.form.mailAddress.$error && !$v.form.mailAddress.email" validation="email" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="v-middle"><span>認証コード</span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <TextBox v-model.trim="$v.form.$model.onetimePassword" placeholder="認証コード" name="mailAddress" />
                  <ValidationErrorMessage v-show="$v.form.onetimePassword.$error && !$v.form.onetimePassword.required" validation="required" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="v-middle"><span>パスワード</span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <Password v-model.trim="$v.form.$model.password" placeholder="パスワード" name="password" />
                  <ValidationErrorMessage v-show="$v.form.password.$error && !$v.form.password.required" validation="required" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="v-middle"><span>確認用パスワード</span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <Password v-model.trim="$v.form.$model.confirmPassword" placeholder="確認用パスワード" name="password" />
                  <ValidationErrorMessage v-show="$v.form.confirmPassword.$error && !$v.form.confirmPassword.required" validation="required" />
                  <ValidationErrorMessage v-show="$v.form.confirmPassword.$error && !$v.form.confirmPassword.sameAsPassword" validation="sameAsPassword" />
                </div>
              </td>
            </tr>
          </table>
          <div class="l-contentsBox__bottom" style="text-align: center;">
            <div class="btn-basic is-inlne is-primary js-savebtn" @click="send()"><a>登録</a></div>
          </div>
        </div>
      </div>
      <notifications group="foo" position="top center" />
    </main>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import Password from '@/components/parts/form/Password.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import { required, sameAs, email } from 'vuelidate/lib/validators';


export default {
  components: {
    Loading,
    TextBox,
    Password,
    ValidationErrorMessage,
  },
  data() {
    return {
      isProcessing: false,
      isSupple: false,
      form: {
        mailAddress: null,
        onetimePassword: null,
        password: null,
        confirmPassword: null,
      }
    }
  },
  validations: {
    form: {
      mailAddress: {
        required,
        email
      },
      onetimePassword: {
        required,
      },
      password: {
        required,
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    }
  },
  created: function() {
    this.isSupple = Object.keys(this.$route.query).includes('supple')
  },
  methods: {
    async send() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/password/setInitPassword', {
          mailAddress: this.form.mailAddress,
          onetimePassword: this.form.onetimePassword,
          password: this.form.password,
        });
        if (res.status === 200) {
          this.$toast.info('パスワードの初期設定が完了しました。');
          if (!this.isSupple) {
            this.$router.push({ name: 'login' });
          }
          else {
            this.$router.push({ name: 'login', query: {supple: null} });
          }
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
  }
}
</script>
